import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class LanguagesParser implements Parser {
	parse(schema: Schema.Languages) {
		const langKeys = Object.keys(schema) as Array<keyof typeof schema>;
		const label = langKeys.map((loc) => `"${schema[loc]?.label}"`).join("|");
		const language = langKeys.map((loc) => `"${schema[loc]?.name}"`).join("|");
		const locale = langKeys.map((loc) => `"${loc}"`).join("|");

		return `
		export interface SiteLanguage {
			domain: { id: number; url: string; slug: string };
			home: string;
			id: number;
			isDefault: boolean;
			label: ${label};
			language: ${language};
			locale: ${locale}
			path: string;
		}
	`;
	}
}
